import { render } from "./ClaimComplementFieldPalette.vue?vue&type=template&id=dd82e9b6"
import script from "./ClaimComplementFieldPalette.vue?vue&type=script&lang=js"
export * from "./ClaimComplementFieldPalette.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ClaimComplementFieldPalette.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_0bcf977f%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fclaim%2Fdetails%2Fcomplement-request%2FClaimComplementFieldPalette.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__